/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessingWorkerModelDto } from '../../models/processing-worker-model-dto';

export interface SuperadminControllerListWorkers$Params {
}

export function superadminControllerListWorkers(http: HttpClient, rootUrl: string, params?: SuperadminControllerListWorkers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProcessingWorkerModelDto>>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerListWorkers.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProcessingWorkerModelDto>>;
    })
  );
}

superadminControllerListWorkers.PATH = '/superadmin/workers';
